// Stable colors for avatars based on a string (phone or name)
const PALETTE = [
  "#075e54",
  "#128c7e",
  "#25d366",
  "#34b7f1",
  "#9c27b0",
  "#ef6c00",
  "#5d4037",
  "#3949ab",
  "#00897b",
  "#6d4c41",
  "#c62828",
  "#ad1457",
];

export function avatarColor(seed) {
  if (!seed) return PALETTE[0];
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = (h << 5) - h + seed.charCodeAt(i);
    h |= 0;
  }
  return PALETTE[Math.abs(h) % PALETTE.length];
}

export function initials(text) {
  if (!text) return "?";
  const trimmed = String(text).trim();
  if (!trimmed) return "?";
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  // Phone numbers — just the first character
  return trimmed.charAt(0).toUpperCase();
}
